import type { SportsDataProvider } from "./types";
import { DemoProvider } from "./DemoProvider";
import { ApiFootballProvider } from "./ApiFootballProvider";
import { supabase } from "@/integrations/supabase/client";

export type ProviderId = "demo" | "api_football";

const STORAGE_KEY = "ss2026:sports_provider";
let cached: ProviderId | null = null;

export function getActiveProviderId(): ProviderId {
  if (cached) return cached;
  if (typeof window !== "undefined") {
    const v = window.localStorage.getItem(STORAGE_KEY);
    if (v === "demo" || v === "api_football") {
      cached = v;
      return v;
    }
  }
  return "api_football";
}

export function setActiveProviderId(id: ProviderId) {
  cached = id;
  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, id);
  }
}

export function getSportsProvider(id?: ProviderId): SportsDataProvider {
  const active = id ?? getActiveProviderId();
  return active === "api_football" ? ApiFootballProvider : DemoProvider;
}

/** Resolve provider id from Supabase feature_flag, falling back to local. */
export async function resolveProviderFromFlag(): Promise<ProviderId> {
  try {
    const { data } = await supabase
      .from("feature_flags")
      .select("payload,enabled")
      .eq("key", "sports_data_provider")
      .maybeSingle();
    const payload = (data?.payload ?? {}) as { value?: string };
    if (payload.value === "api_football" || payload.value === "demo") {
      setActiveProviderId(payload.value);
      return payload.value;
    }
  } catch {
    /* noop */
  }
  return getActiveProviderId();
}

export { DemoProvider, ApiFootballProvider };
export type { SportsDataProvider };